module.exports = __webpack_public_path__ + "img/grey-cat.e4473dd0.png";